import { customElement, bindable, bindingMode } from "aurelia-framework";

@customElement("welcome-header")
export class WelcomeHeader {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public module: string;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public entity: string = "Patient";
}
